<template>
  <div class="contaniner" ref="toolBarCon">
    <div class="toolbar" :style="{'margin-left': marginLeft + 'px' }" ref="toolBar">
      <!-- {{ getToolData }} -->
      <div class="toolItem"  v-for="(item, index) in getToolData" :key="index" :class="[$route.path == item.detail?'active':'','toolItem-'+index]"  @click="redirect(item)"  :ref="'itemMenu-'+index">
          <span class="text">
            {{ item.name }}<i @click.stop="closeToolItem(item, index)" class="el-icon-close i-close"></i>
          </span>
      </div>
      <!-- 下拉列表 -->
      <el-dropdown class="dropdown" @command="onMore" placement="bottom" v-if="barCount>1">
        <div class="i-xiala" :class="{'visibility':showButton}"></div>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item v-for="(item, index) in moreList" :key="index" :command="item.code" :disabled="item.disabled">{{ item.name }}</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      
    </div>

    <!-- 滚动按钮 -->
     <div v-if="showButton" class="btn-con">
      <div class="icon-button">
        <el-dropdown class="dropdown" @command="onMore" placement="bottom" v-if="barCount>1">
          <div class="i-xiala"></div>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item v-for="(item, index) in moreList" :key="index" :command="item.code" :disabled="item.disabled">{{ item.name }}</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
      <div v-if="marginLeft<0" class="icon-button">
          <i class="el-icon-arrow-left" @click="leftmove"></i>
      </div>
      <div v-else class="icon-button">
        <i class="el-icon-arrow-left icon-dis"></i>
      </div>
      <div v-if="canRight" class="icon-button ">
          <i class="el-icon-arrow-right"  @click="rightmove"></i>
      </div>
      <div v-else class="icon-button">
        <i class="el-icon-arrow-right icon-dis"></i>
      </div>
     </div>
    
    <!-- <i name="tabs" class="el-icon-arrow-right" @click="rightmove"></i> -->
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "tabar",
  data() {
    return {
      xxx: 0,
      marginLeft: 0,
      barConWidth:0,
      barWidth: 0,
      showButton:false,
      canRight: false,
      isLogistics: JSON.parse(sessionStorage.getItem("limit")).menuTreeList[0]
        .name,
    };
  },
  computed: {
    ...mapGetters(["getToolData", "getCacheView"]),
    barCount() { 
      return this.getToolData.length
    },
    isHome() { 
      return this.$route.path === '/home'
    },
    //如果首页返回false，如果barCount大于2返回false
    canClose() { 
      return !this.isHome && this.barCount <= 2
    },
    
    moreList() {
      return [
        { name: "关闭当前页", code: "closeCurrent", disabled: this.isHome },
        { name: "关闭其他", code: "closeOther", disabled: this.canClose  },
        { name: "关闭所有", code: "closeAll", disabled:  this.canClose },
      ];
    }
  },
  watch: {
    '$route.path':{
      handler:'initBar',
      immediate:true
    }
  },
  // updated() {
  //   if (!this.getToolData.length && this.isLogistics == "首页") {
  //     this.$router.push({ path: "/home" });
  //   } else if (!this.getToolData.length && this.isLogistics == "物流首页") {
  //     this.$router.push({ path: "/logisticsIndex" });
  //   } else if (!this.getToolData.length && this.isLogistics == "会员首页") {
  //     this.$router.push({ path: "/dashboard" });
  //   }
  // },
  methods: {
    leftmove() {
       let move = 200;
       if( (this.marginLeft + move) < 0) {
         this.marginLeft += move;
       }else{ 
         this.marginLeft = 0;
       }
       this.canRight = true
    },
    rightmove() {
      let move = 200;
      let barWidth = this.barWidth - 44 // 下拉列表的按钮宽度
      if (barWidth + (this.marginLeft - move)  > this.canSeeWidth) {
        this.marginLeft -= move;
        this.canRight = true
       }else{ 
         this.marginLeft =  this.canSeeWidth - barWidth;
         this.canRight = false
       }
       console.log('>>',this.canRight)
      //  console.log('>>',barWidth,)
    },
    closeToolItem(item, index) {
      let tempIndex = this.getToolData.findIndex((v) => {
        if (this.$route.fullPath.indexOf("?") != -1) {
          return this.$route.fullPath.split("?")[0] == v.detail;
        } else {
          return this.$route.fullPath == v.detail;
        }
      });
      this.$store.dispatch("clearToolBar", item);
      this.$store.dispatch("clearCache", item.componentName);
      let path
      if (
        this.getToolData.length >= 1 &&
        this.getToolData.length === tempIndex &&
        tempIndex < index
      ) {
        path = this.getToolData[index - 1].detail;
        this.$router.push({
          path
        });
      } else {
        if (
          this.getToolData.length &&
          !(this.getToolData.length >= tempIndex)
        ) {
          path = this.getToolData[this.getToolData.length - 1].detail,
          this.$router.push({
            path,
          });
        }
      }
      if (tempIndex == index && this.getToolData.length >= 1) {
        path = this.getToolData[this.getToolData.length - 1].detail,
        this.$router.push({
          path
        });
      }
      this.initBar()
      localStorage.setItem('selectedMenuIndex', path)
    },
    redirect(item) {
      if (item.componentName === "addStorage") {
        this.$store.commit("updateTabStorage", true);
      }
      localStorage.setItem('selectedMenuIndex', item.detail)
      let path = item.fullPath || item.detail
      this.$router.push({ path: path });
      
    },
    closeAll() {
      this.$store.commit("closeTar");
    },
    onMore(code){
      console.log('>>',code)
      let path = this.$route.path
      let index = this.getToolData.findIndex(item => item.detail === path)
      let item =  this.getToolData[index]
      
      if(code === 'closeCurrent'){
        // 关闭当前页
        this.closeToolItem(item, index)
      }else if(code === 'closeOther'){
        // 关闭其他
        if (path ==='/home') {
          this.$store.dispatch("clearCacheAll");
        }else{
          this.$store.dispatch("clearCacheOther",item);
        }
        this.$router.push(path)
        this.marginLeft = 0
      }else if(code === 'closeAll'){
        // 关闭所有
        this.$store.dispatch("clearCacheAll");
        this.$router.push('/home')
        this.marginLeft = 0
        localStorage.setItem('selectedMenuIndex','/home')
      }
      
    },
    // 计算toolBar的宽度
    initBar() {
      this.$nextTick(()=>{ 
        setTimeout(()=>{
          this.barConWidth = this.$refs.toolBarCon.offsetWidth; // 外框
          this.barWidth = this.$refs.toolBar.offsetWidth;  // 内容
          let buttonWidth = 158 // 控制按钮
          // 如果内容比外框大，则显示控制按钮
          if(this.barWidth >= this.barConWidth){
            this.showButton = true
            this.canSeeWidth = this.barConWidth - buttonWidth
          }else{
            this.showButton = false
            this.canSeeWidth = this.barConWidth
             this.marginLeft = 0
          }
        
          // console.log('>>', this.showButton,this.barConWidth, this.barWidth, buttonWidth)

          let path = this.$route.path
          let index = this.getToolData.findIndex(item=>item.detail==path)
          // let lastIndex = this.getToolData.length-1
            let name = 'itemMenu-'+index
            // Non-cached routes (e.g. fileCenter) may not have a toolbar tab yet.
            if (index < 0 || !this.$refs[name] || !this.$refs[name][0]) return
            let itemWidth = this.$refs[name][0].offsetWidth
          let itemLeft = this.$refs[name][0].offsetLeft 
          console.table('barConWidth',this.barConWidth,'barWidth',this.barWidth,'canSeeWidth',this.canSeeWidth)
          console.log('marginLeft',this.marginLeft , 'itemLeft',itemLeft ,'itemWidth', itemWidth)
          console.log('itemLeft + itemWidt = ',itemLeft + itemWidth,'marginLeft:',this.marginLeft)
          let marginLeft
          let itemCanSeeWidth = itemLeft + itemWidth // 当前元素的可视宽度
          if (itemCanSeeWidth  >= this.canSeeWidth) {
            marginLeft = this.canSeeWidth - itemCanSeeWidth
            this.marginLeft += marginLeft
            // 是否后面还有元素
            if ( itemCanSeeWidth < this.barWidth ) {
              this.canRight = true
            }else{
              this.canRight = false
            }
          }else if(itemCanSeeWidth <= itemWidth ){
            this.marginLeft = 0
            this.canRight = true
          }else{
            this.canRight = false
          }
          
        },100)
    })
  },
  },
};
</script>

<style scoped lang="scss">
.toolbar {
  overflow-x: scroll;
  /*添加横向滚动条*/
  white-space: nowrap;
  /*不换行*/
  display: inline-block;
  // padding: 0 12px;
  transition: all linear 0.5s;
}

/* 使用伪类选择器 ::-webkit-scrollbar ,兼容chrome和safari浏览器 */
.toolbar::-webkit-scrollbar {
  display: none;
}

/*兼容火狐*/
.toolbar {
  scrollbar-width: none;
}

/* 兼容IE10+ */
.toolbar {
  -ms-overflow-style: none;
}
.toolItem{
  display: inline-block;
  height: 40px;
  line-height: 40px;
  white-space: nowrap;
  cursor: pointer;
  padding-left: 20px;
  border-radius: 8px 8px 0 0;
  font-size: 16px;
  position: relative;
  &::after{
    content: '';
    position: absolute;
    top: 10px;
    right: -1px;
    width: 1px;
    height: 20px;
    background: #D7DCDB;
  }
  .i-close{
    font-size: 13px;
    padding: 6px 10px;
    visibility: hidden;
    color: #999B9B;
  }
  &:hover {
    background-color: #F5F5F5;
    transition: all 0.5s;
    &::after{
      display: none;
    }
    .i-close{
      visibility:initial;
    }
  }
}
.active {
  // border-top: 1px solid #999 !important;
  background-color: #FFF;
  color: #00B498!important;
  .i-close{
    visibility:initial;
  }
  &::after{
    display: none;
  }
  &:hover {
    background-color: #FFF;
  }
}
.toolItem-0{
  width: 56px;
  height: 40px;
  padding: 0;
  margin-left: 8px;
  
  &::before{
    content: '';
    display: inline-block;
    width: 56px;
    height:16px;
    background-image: url('~@/assets/icon_zhuye.png');
    background-position: center;
    background-repeat: no-repeat;
    background-size: 16px 16px
  }
  .text{
    font-size: 0;
  }
  .i-close{
    display: none;
  }
}
.i-xiala{
  display: inline-block;
  width: 14px;
  height:20px;
  background-image: url('~@/assets/icon_xiala.png');
  background-size: 14px 14px;
  background-repeat: no-repeat;
  background-position: center 6px;
  margin: 0 10px;
  padding: 0 5px;
  cursor: pointer;
}
.btn-con{
  position: absolute;
  right: 0;
  bottom: 0;
  height: 40px;
  width: 157px;
  display: flex;
  align-items: center;
  background-color: #F5FAF9;
  &::before{
    content: '';
    position: absolute;
    top: 10px;
    left:0;
    width: 1px;
    height: 20px;
    background: #D7DCDB;
  }
  .icon-button{
    width: 47px;
    height: 20px;
    padding: 5px 0;
    position: relative;
    // background: rgba($color: #000000, $alpha:1);
    display: flex;
    justify-content: center;
    align-items: center;
    &::after{
      content: '';
      position: absolute;
      top: 5px;
      right:0;
      width: 1px;
      height: 20px;
      background: #D7DCDB;
    }
  }
  .el-icon-arrow-left,
  .el-icon-arrow-right{
    color: #939696;
    cursor: pointer;
  }
  .icon-dis{
      color: #dcdcdc;
      cursor: no-drop;
  }
}
// .el-icon-arrow-right {
//   position: absolute;
//   top: 8px;
//   right: 0px;
//   background: #fff;
//   padding-right: 8px;
//   z-index: 100;
// }

// .el-icon-arrow-left {
//   position: absolute;
//   top: 8px;
//   right: 30px;
//   background: #fff;
//   padding-left: 8px;
//   z-index: 100;
// }
.visibility{
  visibility: hidden;
}
</style>
